import Spacer from "components/spacer/Spacer";
import { memo } from "react";
import SmartLink from "components/smartLink/SmartLink";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "hooks";
import { languageSelector } from "selectors/uiSelectors";
import { localizePath } from "utility/languageUtility";

const Wrapper = styled.div`
  background: #222222;
  color: white;
  display: flex;
  align-items: center;
  height: 34px;
  justify-content: center;
`;

const InnerWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  display: flex;
  align-items: center;

  @media (max-width: 699px) {
    justify-content: center;
  }
`;

const Copy = styled.div`
  padding-left: 10px;
  display: flex;
  align-items: center;
  font-size: 0.9rem;

  @media (max-width: 699px) {
    padding-left: 0;
  }
`;

const Links = styled.div`
  flex: 1;
  display: flex;
  justify-content: right;
  align-self: stretch;
  align-items: center;

  @media (max-width: 699px) {
    display: none;
  }
`;

const Link = styled(SmartLink)`
  text-align: center;
  padding: 0 10px;
  font-size: 0.9rem;
  align-items: center;
  display: flex;
  color: white;
  text-decoration: none;
  &:hover {
    text-decoration: underline !important;
  }
`;

const FooterSpacer = styled(Spacer)`
  height: 18px;
  margin: 8px 0;
  align-self: center;
`;

const Footer = () => {
  const { t } = useTranslation("common");
  const language = useAppSelector(languageSelector);
  const lp = (path: string) => localizePath(path, language);
  return (
    <>
      <Wrapper>
        <InnerWrapper>
          <Copy>
            &copy; DomainFindr{" "}
            <span suppressHydrationWarning>{new Date().getFullYear()}</span>
          </Copy>
          <Links>
            <Link to={lp("/terms-and-conditions")}>
              {t("footer.termsAndConditions")}
            </Link>
            <FooterSpacer color={"white"} />
            <Link to={lp("/privacy-policy")}>{t("footer.privacyPolicy")}</Link>
            <FooterSpacer color={"white"} />
            <Link to={lp("/contact")}>{t("footer.contact")}</Link>
            <FooterSpacer color={"white"} />
            <Link
              to={"https://massgenerate.com"}
              target="_blank"
              rel="noopener noreferrer"
            >
              MassGenerate
            </Link>
            <FooterSpacer color={"white"} />
            <Link
              to={"https://toolweaver.com"}
              target="_blank"
              rel="noopener noreferrer"
            >
              ToolWeaver
            </Link>
          </Links>
        </InnerWrapper>
      </Wrapper>
    </>
  );
};

export default memo(Footer);
